import JobOfferDetails from './JobOfferDetails'
export default JobOfferDetails
